import { useContext } from 'react';

import { useQuery } from '@apollo/client';

import { AuthContext } from 'auth';

import { IGameAccountsGroupsResponse, IReturnValue } from './interfaces';
import { GAME_ACCOUNTS_GROUPS } from './schemas';

export const useGameAccountsOptions = (): IReturnValue => {
  const {
    data: { permissions },
  } = useContext(AuthContext);

  const { data } = useQuery<IGameAccountsGroupsResponse>(GAME_ACCOUNTS_GROUPS, {
    fetchPolicy: 'no-cache',
    skip: !permissions?.has('game_account_browse'),
  });

  return {
    isLoaded: permissions?.has('game_account_browse')
      ? Boolean(data?.gameAccountGroups)
      : true,
    options:
      data?.gameAccountGroups.map(({ id, title }) => ({ value: id, title })) ??
      [],
  };
};
